module.exports = __webpack_public_path__ + "img/x-icon.b742d879.svg";